import { combineReducers } from "redux";

import { advancedsearch } from "./advancedsearch";
import { preferences } from "./preferences";
import { reactions } from "./reactions";
import { savedStructures } from "./savedStructures";
import { scoreWeights } from "./scoreWeights";
import { sdsPersistent } from "./sds";

export const persistent = combineReducers({
    advancedsearch,
    saved_structures: savedStructures,
    reactions,
    scoreWeights,
    sdsPersistent,
    preferences,
});
